import "./ProjectsStyle.css";
import { ProjectData } from "../../Utils/localdata";
import { FiRefreshCw } from "react-icons/fi";
import Heading from "../../SubComponents/Heading/Heading";
import Github from "../../SubComponents/Github/Github";
import Arrow from "../../SubComponents/Arrow/Arrow";
import { motion } from "framer-motion";
import { ScreenContext } from "../../Utils/contexts";
import { useContext } from "react";

export default function Projects() {
  const { isLaptop } = useContext(ScreenContext);

  const ProjectSection = () => {
    return ProjectData.map((item, index) => {
      const {
        projName,
        projColor,
        image,
        Description,
        skills,
        github,
        site,
        specialSymbol,
      } = item;
      const box1Variants = isLaptop
        ? {
            initial: { x: 0 },
            hover: { x: "-40%" },
            exit: { x: 0 },
          }
        : "";
      const box2Variants = {
        initial: { x: 0 },
        hover: { x: "40%" },
        exit: { x: 0 },
      };

      return (
        <motion.div className="slider-container" whileHover="hover" key = {index}>
          <motion.div
            className="box1 box"
            variants={box1Variants}
            transition={{ ease: "easeOut", duration: 1 }}
          >
            <div className="project-content">
              <div className="project-section-one">
                <div className="project-header">
                  <div
                    className="projTitle"
                    style={{ color: `var(--project-${projColor})` }}
                  >
                    {projName} {specialSymbol}
                  </div>
                  <Github
                    github={github}
                    projColor={projColor}
                    cls="desc-icon"
                  />
                </div>

                <div className="proj-description">{Description}</div>
              </div>

              <div className="proj-section-two">
                <div className="skill-set">
                  {skills.map((item, index) => {
                    return (
                      <motion.div
                        whileHover={{ scale: 1.1 }}
                        className="proj-skills"
                        style={{
                          backgroundColor: `var(--project-${projColor})`,
                        }}
                        key={index}
                      >
                        {item}
                      </motion.div>
                    );
                  })}
                </div>
                <Arrow site={site} projColor={projColor} cls="desc-icon" />
              </div>
            </div>
          </motion.div>
          {isLaptop && (
            <motion.div
              transition={{ ease: "easeOut", duration: 1 }}
              variants={box2Variants}
              className="box2 box"
              style={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            >
              <div className="proj-div-upper">
                <div className="projColor icon">{item["id"]}</div>
                <Github github={github} projColor={"black"} />
              </div>
              <div className="proj-div-upper">
                <FiRefreshCw size={25} color="black" className="icon" />
                <Arrow
                  site={site}
                  projColor={"black"}
                  className="proj-desc-img"
                />
              </div>
            </motion.div>
          )}
        </motion.div>
      );
    });
  };

  return (
    <div className="project-section" id="projects" data-aos="fade-up">
      <div className="heading-container">
        <Heading index={3} className="heading-div">
          Projects
        </Heading>
      </div>
      <div className="projects">
        <ProjectSection />
      </div>
    </div>
  );
}
